<template>
  <div>
    <el-form :inline="true">
      <el-row>
        <el-col :span="6">
          <el-form-item label="患儿姓名">
            <el-input type="text" v-model="form.searchCond.childName" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="手机号">
            <el-input type="text" v-model="form.searchCond.loginAccount" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <SearchButton @search="queryList" @reset="reset" @expand="e => expand = e">
            <el-button icon="el-icon-plus" type="primary" size="small" @click="newBtnFunction">新增</el-button>
          </SearchButton>
        </el-col>
      </el-row>
      <el-row v-if="expand">
        <el-col :span="6">
          <el-form-item label="注册状态">
            <DictionarySelect v-model="form.searchCond.helpStatusList" :lazy="true" tableCode="HELP_STATUS" :multiple="true" :filterable="false">
            </DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="申请状态">
            <DictionarySelect v-model="form.searchCond.apprStatusList" :lazy="true" tableCode="APPROVE_STATUS" :multiple="true" :excludeKeys="['5', '6']">
            </DictionarySelect>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="注册时间">
            <el-date-picker v-model="time" type="daterange" start-placeholder="开始日期"
                            end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" @change="changeTime" size="small"
                            :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="身份证号">
            <el-input type="text" v-model="form.searchCond.idNumber" size="small" placeholder="请输入" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import HospitalSelect from "@/components/business/HospitalSelect";
  import DiseaseCascader from "@/components/business/DiseaseCascader";
  import SearchButton from "@/components/business/SearchButton";
  import DictionarySelect from "@/components/business/DictionarySelect"
  import LocationCascader from "@/components/business/LocationCascader"

  export default {
    props: {
      queryForm: {},
    },
    components: {
      HospitalSelect,
      SearchButton,
      DiseaseCascader,
      DictionarySelect,
      LocationCascader
    },
    data() {
      let isHospitalRole = this.isHospital();
      return {
        isHospitalRole: isHospitalRole,
        pickerOptions: {},
        time: [], //开始结束时间
        expand: false,
        form: this.queryForm,
        openScreen1: false,
        hospitalOptions: [], //救助医院数据
        diseaseOptions: [],
        helpStatus: [], // 救助状态数据
        valueParentId: '',
        level: 0,
        disease: '', //病种
        location: '', //户口所在地
      }
    },
    methods: {
      reset() {
        this.disease = []
        this.location = []
        this.time = [];
        this.queryForm.searchCond = {
          childName: null, //患儿姓名
          apprStatus: null, //患儿姓名
          diseasesId: null, //病种
          idNumber: null, //身份证号
          province: null, //所在省
          city: null, //所在市
          county: null, //所在区县
          registerTimeBegin: null, //注册时间（开始）
          registerTimeEnd: null, //注册时间（结束）
          loginAccount: null, //登录账号
          helpStatus: null, //救助状态
          quotaType: null,
          hospitalId: null,
          isTimeout: 0,
        }
        this.form.pageNO = 1
        this.$emit('query', this.form)
      },
      // 选择时间
      changeTime(e) {
        this.form.searchCond.registerTimeBegin = e[0]
        this.form.searchCond.registerTimeEnd = e[1]
      },
      // 选择户口所在地
      handleChange(e) {
        this.form.searchCond.province = e[0]
        this.form.searchCond.city = e[1]
        this.form.searchCond.county = e[2]
      },
      queryList() {
        this.form.pageNO = 1
        this.$emit('query', this.form)
      },
      newBtnFunction() {
        this.$emit('newBtnFun')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "src/common/form";
</style>



// WEBPACK FOOTER //
// src/pages/child/register/ChildTableSearch.vue